import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Custom category picker for flat_feed_v3 (replaces native select + flat-feed-v3-filter).
export default class extends Controller {
  static targets = ["trigger", "panel"];

  connect() {
    this.boundDocClick = this.onDocumentClick.bind(this);
    this.boundKeydown = this.onKeydown.bind(this);
  }

  disconnect() {
    this.close();
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.panelTarget.hidden) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    if (!this.panelTarget.hidden) return;
    this.panelTarget.hidden = false;
    this.element.classList.add("is-open");
    this.triggerTarget.setAttribute("aria-expanded", "true");
    document.addEventListener("click", this.boundDocClick);
    document.addEventListener("keydown", this.boundKeydown);
  }

  close() {
    if (!this.hasPanelTarget) return;
    this.panelTarget.hidden = true;
    this.element.classList.remove("is-open");
    this.triggerTarget.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.boundDocClick);
    document.removeEventListener("keydown", this.boundKeydown);
  }

  onDocumentClick(event) {
    if (this.element.contains(event.target)) return;
    this.close();
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close();
  }

  select(event) {
    event.preventDefault();
    const id = event.currentTarget.dataset.categoryId || "";
    const url = new URL(window.location.href);
    const current = url.searchParams.get("q[category_id_eq]") || "";
    if (id === current) {
      this.close();
      return;
    }

    url.searchParams.delete("q[category_id_eq]");
    if (id.trim() !== "") url.searchParams.set("q[category_id_eq]", id);
    url.searchParams.delete("page");
    this.close();
    Turbo.visit(url.toString());
  }
}
